import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { API_BASE_URL } from './config'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
      posts: {},
      allPosts: {},
      multiverseCards: {},
      session: {},
      selectedCardId: {},
      selectedCard: {},
      scrollImages: {}
    },
    mutations: {
      filterMultiverseIds (state, scryfallId) {
        state.posts = state.allPosts.filter(function(post) {
          return post.scryfallId == scryfallId
        })
      },
      updatePosts (state, posts) {
        state.allPosts = posts
      },
      updateFilteredPosts (state, posts) {
        state.posts = posts
        console.log('done updating posts')
      },
      updateMultiverseCards (state, multiverseCards) {
        state.multiverseCards = multiverseCards
      },
      setAuthToken (state, authToken) {
        state.session = authToken
      },
      updateSelectedCardId (state, selectedCardId) {
        state.selectedCard = selectedCardId
      },
      updateSelectedCard (state, selectedCard) {
        state.selectedCard = selectedCard
      }
    },
    actions: {
      async fetchPosts ({ commit }, multiverseId) {
        return new Promise((resolve, reject) => {
          axios.get(API_BASE_URL + '/post/scryfall/' + multiverseId).then(function (response) {
            commit('updatePosts', response.data.posts)
            commit('updateFilteredPosts', response.data.posts)
            commit('updateMultiverseCards', response.data.multiverseCards)
            resolve()
          }, function () {
            console.log('error fetching posts')
            reject()
          })
        })
      },
      async filterPosts ({ commit, state }, payload) {
        var multiverseId = payload.multiverseId
        var scryfallId = payload.scryfallId

        return new Promise((resolve, reject) => {
          try {
            var posts = state.allPosts.filter(function(post) {
              if (post.scryfallId == scryfallId || post.multiverseId == multiverseId) {
                return true
              }
              //console.log(return post.scryfallId == scryfallId)
            })
            commit('updateFilteredPosts', posts)
            resolve()
          } catch (e) {
            console.log('error filtering posts')
            reject()
          }
        })
      },
      async setSessionCookie ({ commit }, payload) {
        commit('setAuthToken', payload)
      },
      async selectCard ({ commit }, payload) {
        console.log('card select')
        await commit('updateSelectedCardId', payload.cardId)
        const response = await axios.get(API_BASE_URL + '/card/scryfall/' + this.state.selectedCard)
        var selectedCard = response.data
        selectedCard.image = 'https://api.scryfall.com/cards/' + selectedCard.setCode.toLowerCase() + '/' + selectedCard.number + '/en' + '/?format=image&version=png'
        selectedCard.castingCost = selectedCard.manaCost
        await commit('updateSelectedCard', selectedCard)
        if (payload.refresh == true) {
          console.log('search true')
          this.dispatch('fetchPosts', selectedCard.scryfallId)
        }
      },
    }
})

export default store
